import { render, staticRenderFns } from "./LanguageSetting.vue?vue&type=template&id=54fbefb9&scoped=true&"
import script from "./LanguageSetting.vue?vue&type=script&lang=ts&"
export * from "./LanguageSetting.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSetting.vue?vue&type=style&index=0&id=54fbefb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fbefb9",
  null
  
)

export default component.exports